var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0 h-100"},[_vm._m(0),_c('sms-grid')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('strong',[_vm._v("SMS")]),_vm._v(" history")])
}]

export { render, staticRenderFns }